app.controller("StudentNewSelectionInstructionController", [
    "$scope", "AuthService", "$state", "UserConfigService", "$q",
    function ($scope, AuthService, $state, UserConfigService, $q) {
        $scope.show = true;

        AuthService.getUserData().then(function (data) {
            $scope.user = data;
            if(AuthService.user.userConfig.informed) $scope.show = false;
        });

        $scope.agree = function () {
            UserConfigService.set({key: 'informed', value: true});
            AuthService.user.userConfig.informed = true;
            $scope.show = true;
            $state.go("student-new.selection", {});
        };
    }
]);